"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var STORAGE = window.localStorage || {};
var EventStore = /** @class */ (function () {
    function EventStore(context, trace) {
        this.context = context;
        this.trace = trace;
        this.key = "SEISMIC_CENTRAL_EVENTS_CLIENT_" + JSON.stringify(context) + "<>" + JSON.stringify(trace);
        this.paddingKey = this.key + "_pedding";
    }
    EventStore.parseEventsStr = function (eventsStr) {
        if (eventsStr) {
            try {
                return JSON.parse(eventsStr);
            }
            catch (e) {
                return null;
            }
        }
        else {
            return null;
        }
    };
    EventStore.prototype.isEmpty = function () {
        var events = this.getEvents();
        return !(events && events.length > 0);
    };
    EventStore.prototype.getEvents = function () {
        var eventsStr = STORAGE[this.key];
        return EventStore.parseEventsStr(eventsStr);
    };
    EventStore.prototype.popEvents = function () {
        var currentStr = STORAGE[this.key];
        var penddingStr = STORAGE[this.paddingKey];
        var current = EventStore.parseEventsStr(currentStr);
        var pendding = EventStore.parseEventsStr(penddingStr);
        STORAGE[this.key] = 'null';
        if (pendding) {
            STORAGE[this.paddingKey] = current
                ? JSON.stringify(current.concat(pendding))
                : penddingStr;
        }
        else {
            STORAGE[this.paddingKey] = currentStr;
        }
        var events = EventStore.parseEventsStr(currentStr);
        return __assign(__assign({}, this.trace), { context: this.context, EventData: events });
    };
    EventStore.prototype.onSuccess = function () {
        STORAGE[this.paddingKey] = 'null';
    };
    EventStore.prototype.onFailed = function () {
        var currentStr = STORAGE[this.key];
        var penddingStr = STORAGE[this.paddingKey];
        var current = EventStore.parseEventsStr(currentStr);
        var pendding = EventStore.parseEventsStr(penddingStr);
        if (!current) {
            STORAGE[this.key] = penddingStr;
        }
        else if (!pendding) {
            // do nothing
        }
        else {
            STORAGE[this.key] = JSON.stringify(current.concat(pendding));
            STORAGE[this.paddingKey] = 'null';
        }
    };
    EventStore.prototype.addEvent = function (eventData) {
        var events = this.getEvents();
        if (events) {
            events.push(eventData);
        }
        else {
            events = [eventData];
        }
        STORAGE[this.key] = JSON.stringify(events);
        return events;
    };
    return EventStore;
}());
exports.default = EventStore;
//# sourceMappingURL=EventStore.js.map